module.exports = __webpack_public_path__ + "img/popup.bcde381.png";